export default __webpack_public_path__ + "static/media/competition_day_tile.e6b2ce7b.jpg";